export const isStringExist = (str: string | undefined, isLast?: boolean) =>
	str !== ''
		?
		`${str}${isLast ? '' : ', '}`
		: '';